import { getFirestore, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { app } from "../../firebase-config.js";
import { Toast } from "../common/Toast.js";

const db = getFirestore(app);

export class AuthorApplicationModal {
    constructor(user, onSuccess) {
        this.user = user;
        this.onSuccess = onSuccess;
        this.wrapper = null;
    }

    render() {
        const modalHtml = `
            <div id="author-modal" class="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fade-in">
                <div class="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl scale-95 opacity-0 transition-all duration-300" id="author-modal-box">
                    <div class="p-6">
                        <div class="flex justify-between items-start mb-4">
                            <div>
                                <h3 class="text-xl font-bold text-gray-900">${window.locale.t('author.apply_title')}</h3>
                                <p class="text-sm text-gray-500 mt-1">${window.locale.t('author.apply_desc')}</p>
                            </div>
                            <button id="btn-close-modal" class="text-gray-400 hover:text-gray-600">
                                <span class="material-symbols-outlined">close</span>
                            </button>
                        </div>

                        <div class="space-y-4">
                            <div>
                                <label class="block text-xs font-bold text-gray-700 uppercase mb-1">${window.locale.t('author.email_label')} <span class="text-red-500">*</span></label>
                                <input type="email" id="input-email" class="w-full border border-gray-300 rounded-xl p-3 text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none" placeholder="${window.locale.t('author.email_placeholder')}" value="${this.user.email || ''}">
                                    <p class="text-xs text-gray-400 mt-1">${window.locale.t('author.email_hint')}</p>
                            </div>
                            <div>
                                <label class="block text-xs font-bold text-gray-700 uppercase mb-1">${window.locale.t('author.intro_label')} <span class="text-red-500">*</span></label>
                                <textarea id="input-intro" rows="4" class="w-full border border-gray-300 rounded-xl p-3 text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none resize-none" placeholder="${window.locale.t('author.intro_placeholder')}"></textarea>
                            </div>
                            <div>
                                <label class="block text-xs font-bold text-gray-700 uppercase mb-1">${window.locale.t('author.portfolio_label')}</label>
                                <input type="text" id="input-portfolio" class="w-full border border-gray-300 rounded-xl p-3 text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none" placeholder="https://...">
                            </div>
                        </div>

                        <div class="mt-8">
                            <button id="btn-submit-app" class="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl shadow-lg transition-transform active:scale-[0.98] flex items-center justify-center gap-2">
                                <span class="material-symbols-outlined">send</span> ${window.locale.t('author.submit_btn')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        this.wrapper = document.createElement('div');
        this.wrapper.innerHTML = modalHtml;
        document.body.appendChild(this.wrapper);

        const box = this.wrapper.querySelector('div[id$="-modal-box"]');

        requestAnimationFrame(() => {
            box.classList.remove('scale-95', 'opacity-0');
            box.classList.add('scale-100', 'opacity-100');
        });

        // Close Handler
        this.wrapper.querySelector('#btn-close-modal').onclick = () => this.close();

        // Submit Handler
        const submitBtn = this.wrapper.querySelector('#btn-submit-app');
        submitBtn.onclick = () => this.handleSubmit(submitBtn);
    }

    close() {
        const box = this.wrapper.querySelector('div[id$="-modal-box"]');
        box.classList.remove('scale-100', 'opacity-100');
        box.classList.add('scale-95', 'opacity-0');
        setTimeout(() => this.wrapper.remove(), 200);
    }

    async handleSubmit(submitBtn) {
        const intro = this.wrapper.querySelector('#input-intro').value.trim();
        const pf = this.wrapper.querySelector('#input-portfolio').value.trim();
        const email = this.wrapper.querySelector('#input-email').value.trim();

        if (!email) {
            Toast.show(window.locale.t('author.email_required'), 'error');
            return;
        }
        if (!intro) {
            Toast.show(window.locale.t('author.intro_required'), 'error');
            return;
        }

        try {
            submitBtn.textContent = window.locale.t('author.submitting');
            await updateDoc(doc(db, "users", this.user.uid), {
                authorStatus: 'pending',
                authorRequestData: {
                    introduction: intro,
                    portfolioUrl: pf,
                    contactEmail: email,
                    requestedAt: serverTimestamp()
                }
            });
            this.user.authorStatus = 'pending';
            this.close();
            Toast.show(window.locale.t('author.submit_success'));
            if (this.onSuccess) this.onSuccess();
        } catch (e) {
            console.error(e);
            Toast.show(window.locale.t('common.error') + ': ' + e.message, 'error');
            submitBtn.innerHTML = `<span class="material-symbols-outlined">send</span> ${window.locale.t('author.submit_btn')}`;
        }
    }
}
